import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, trend, trendValue, description, loading = false }) => {
  const isPositiveTrend = trend === 'up';

  if (loading) {
    return (
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <div className="h-4 bg-slate-200 rounded w-24 animate-pulse"></div>
          <div className="h-8 w-8 bg-slate-200 rounded animate-pulse"></div>
        </CardHeader>
        <CardContent>
          <div className="h-8 bg-slate-200 rounded w-16 mb-2 animate-pulse"></div>
          <div className="h-3 bg-slate-200 rounded w-32 animate-pulse"></div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="hover:shadow-lg transition-shadow duration-200">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-slate-600">
          {title}
        </CardTitle>
        {Icon && (
          <div className="p-2 bg-amber-100 rounded-lg">
            <Icon className="h-5 w-5 text-amber-600" />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold text-slate-900 mb-1">
          {value}
        </div>
        {(trendValue || description) && (
          <div className="flex items-center gap-2 text-xs">
            {trendValue && (
              <span
                className={`flex items-center gap-1 font-medium ${
                  isPositiveTrend ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {isPositiveTrend ? (
                  <ArrowUpIcon className="w-3 h-3" />
                ) : (
                  <ArrowDownIcon className="w-3 h-3" />
                )}
                {trendValue}
              </span>
            )}
            {description && (
              <span className="text-slate-500">
                {description}
              </span>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
